/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { PlayContentButtonProps } from "./types";

export type { PlayContentButtonProps };

export default CustomPlatform.select<() => React.FC<PlayContentButtonProps>>({
  tv: () => require("./PlayContentButton.tv").default,
  web: () => require("./PlayContentButton.web").default,
  native: () => require("./PlayContentButton").default,
})();
